import React from 'react';
import PropTypes from 'prop-types';
import PictionJS from 'piction-js';
import classNames from 'classnames';
import { List } from 'immutable';
import UMOGridItem from '../UMOGridItem';
import { SearchParams } from '../../utils/searchUtils';

// serves as a wrapper for non justified grid item component
function UMOGridNoJItemSmall({
  umo,
  customMetatag,
  onDetailViewClick,
  toggleFullImageView,
  selectedWorkspaceData,
  dispatch,
  isSelected,
  isUMOGalleryWorkspace,
  searchParams,
  selectedUMOIDs,
  isSelectAll,
  workspaceCardsViewTimes,
  highlightSetID,
  galleryType,
}) {
  return (
    <div
      className={classNames(
        'umo-grid-item-noj',
        'umo-grid-item-small',
        { 'umo-grid-item-noj--selected': isSelected }
      )}
    >
      <UMOGridItem
        onDetailViewClick={onDetailViewClick}
        toggleFullImageView={toggleFullImageView}
        isNotJustified
        isSmallGrid
        umo={umo}
        customMetatag={customMetatag}
        searchParams={searchParams}
        selectedUMOIDs={selectedUMOIDs}
        isSelectAll={isSelectAll}
        isSelected={isSelected}
        selectedWorkspaceData={selectedWorkspaceData}
        isUMOGalleryWorkspace={isUMOGalleryWorkspace}
        dispatch={dispatch}
        workspaceCardsViewTimes={workspaceCardsViewTimes}
        highlightSetID={highlightSetID}
        galleryType={galleryType}
      />
    </div>
  );
}

UMOGridNoJItemSmall.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO).isRequired,
  selectedUMOIDs: PropTypes.instanceOf(List),
  searchParams: PropTypes.instanceOf(SearchParams),
  isSelectAll: PropTypes.bool,
  isSelected: PropTypes.bool,
  isUMOGalleryWorkspace: PropTypes.bool,
  onDetailViewClick: PropTypes.func,
  toggleFullImageView: PropTypes.func,
  dispatch: PropTypes.func,
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  customMetatag: PropTypes.string,
  workspaceCardsViewTimes: PropTypes.shape({
    catid: PropTypes.string,
    usernm: PropTypes.string,
    viewtimes: PropTypes.array,
  }),
  highlightSetID: PropTypes.string,
  galleryType: PropTypes.string,
};

export default UMOGridNoJItemSmall;



// WEBPACK FOOTER //
// ./src/js/components/UMOGridNoJItemSmall/index.jsx